import { useContext, useEffect } from "react";
import ModuleCard from "../../components/ModuleCard/ModuleCard";
import { IExploreProps } from "./Explore.interface";
import { TranslationContext } from "../../shared/providers/translation/translation.provider";
import { Outlet, useOutlet } from "react-router-dom";
import { ModuleContext } from "../../shared/providers/module/module.provider";
import { AnalyticsContext } from "../../shared/providers/analytics/analytics.provider";
import { AuthenticationContext } from "../../shared/providers/authentication/authentication.provider";

function Explore(props: IExploreProps) {
    const { translate } = useContext(TranslationContext);
    const { pathwayModules } = useContext(ModuleContext);
    const { setEvent } = useContext(AnalyticsContext);
    const { user } = useContext(AuthenticationContext);
    const outlet = useOutlet();

    useEffect(() => {
        if (outlet || !user?.id) return;

        setEvent({
            event_name: "app_explore_view",
            event_category: "page_view",
            event_action: "app_explore_view",
            user_token: user.id,
            company_id: user?.company.id,
        });
    }, [outlet, user?.id]);

    return (
        <>
            {outlet && <Outlet />}
            {!outlet && (
                <div className="pt-11 pt-md-0 px-1 px-md-31 pb-22">
                    <h1 className="text-h2-bd text-h1-bd-md mb-3 mb-md-2">
                    {translate("nav.all_topics", "All Topics")}
                    </h1>

                    <section aria-labelledby="topics">
                        <div className="row g-12">
                            {pathwayModules?.map((module) => (
                                <div className="col-12 col-lg-3 d-flex" key={module.id}>
                                    <ModuleCard
                                        {...module}
                                        title={module.title}
                                        contentAmount={module.contentAmount}
                                        description={module.description}
                                    />
                                </div>
                            ))}
                        </div>
                    </section>
                </div>
            )}
        </>
    );
}

export default Explore;
